import { z } from 'zod'

import type { GetNotificationSettingsData } from '~/api-spec/__generated__/main'
import { parseApiResponse } from '~/schema/apiBoundary'

import {
  type Notification,
  type NotificationPage,
  NotificationPageSchema,
  NotificationSchema,
  type PdfStatusMessage,
  PdfStatusMessageSchema,
  type PushNotificationSetting,
  PushNotificationSettingSchema,
  type StatusUpdateMessage,
  StatusUpdateMessageSchema,
} from './schemas'

const ENTITY = 'Notification'

// 메시징 서버와 실시간 채널은 생성 타입이 없어 입력을 unknown 으로 받는다. 검증 뒤 모양은 스키마가 정한다.
export const adaptNotificationPage = (raw: unknown): NotificationPage => {
  const page = parseApiResponse(NotificationPageSchema, raw, ENTITY)
  return { result: page?.result ?? [], hasBefore: page?.hasBefore ?? false }
}

export const adaptNotification = (raw: unknown): Notification =>
  parseApiResponse(NotificationSchema, raw, ENTITY)

export const adaptUnreadNotificationCount = (raw: unknown): number =>
  parseApiResponse(z.number(), raw, ENTITY)

export const adaptPdfStatusMessage = (raw: unknown): PdfStatusMessage =>
  parseApiResponse(PdfStatusMessageSchema, raw, ENTITY)

export const adaptStatusUpdateMessage = (raw: unknown): StatusUpdateMessage =>
  parseApiResponse(StatusUpdateMessageSchema, raw, ENTITY)

// 보고서 목록 갱신 신호는 다시 불러올 보고서 id 목록만 싣는다.
export const adaptReportRefreshMessage = (raw: unknown): number[] =>
  parseApiResponse(z.array(z.number()), raw, ENTITY) ?? []

export const adaptPushNotificationSetting = (
  raw: GetNotificationSettingsData,
): PushNotificationSetting => parseApiResponse(PushNotificationSettingSchema, raw, 'Notification')
